__turbopack_context__.v({
  "alertYellow": "_9a93ra_alertYellow",
  "backgroundImage": "_9a93ra_backgroundImage",
  "black": "_9a93ra_black",
  "black90": "_9a93ra_black90",
  "bullet": "_9a93ra_bullet",
  "content": "_9a93ra_content",
  "ctas": "_9a93ra_ctas",
  "cyan": "_9a93ra_cyan",
  "darkStone": "_9a93ra_darkStone",
  "desktopTicker": "_9a93ra_desktopTicker",
  "fullStop": "_9a93ra_fullStop",
  "fuschiaPunch": "_9a93ra_fuschiaPunch",
  "item": "_9a93ra_item",
  "limeSorbet": "_9a93ra_limeSorbet",
  "mobileStack": "_9a93ra_mobileStack",
  "olive100": "_9a93ra_olive100",
  "olive20": "_9a93ra_olive20",
  "paddingBottom0": "_9a93ra_paddingBottom0",
  "paddingBottom112": "_9a93ra_paddingBottom112",
  "paddingBottom128": "_9a93ra_paddingBottom128",
  "paddingBottom16": "_9a93ra_paddingBottom16",
  "paddingBottom32": "_9a93ra_paddingBottom32",
  "paddingBottom48": "_9a93ra_paddingBottom48",
  "paddingBottom64": "_9a93ra_paddingBottom64",
  "paddingBottom80": "_9a93ra_paddingBottom80",
  "paddingBottom96": "_9a93ra_paddingBottom96",
  "paddingTop0": "_9a93ra_paddingTop0",
  "paddingTop112": "_9a93ra_paddingTop112",
  "paddingTop128": "_9a93ra_paddingTop128",
  "paddingTop16": "_9a93ra_paddingTop16",
  "paddingTop32": "_9a93ra_paddingTop32",
  "paddingTop48": "_9a93ra_paddingTop48",
  "paddingTop64": "_9a93ra_paddingTop64",
  "paddingTop80": "_9a93ra_paddingTop80",
  "paddingTop96": "_9a93ra_paddingTop96",
  "softBlack": "_9a93ra_softBlack",
  "teal100": "_9a93ra_teal100",
  "teal20": "_9a93ra_teal20",
  "tickerTapeSection": "_9a93ra_tickerTapeSection",
  "warmStone": "_9a93ra_warmStone",
  "white": "_9a93ra_white",
});
